import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import routes from '../../routes';

const LandingPage = () => {
    const history = useHistory();
    const routeEntries = Object.entries(routes);
    const actualRoutes = routeEntries.filter(([key, value]) => Object.keys(value).includes('path'));
    const initialRoute = actualRoutes.length ? actualRoutes[0] : null;
    if (initialRoute === null) {
        throw Error('Initial route not found');
    }

    const [, { path }] = initialRoute;

    useEffect(() => {
        history.push(path);
    }, []);

    return <></>;
};

export default LandingPage;
